import gsap from 'gsap';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { isMobile } from '../_app/cuchillo/core/Basics';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';

class ScrollItem__Footer extends VScroll_Item {
  items;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.setUpAnimation();

    this._call = () => this.loop();
    this.onShow = () => {
      gsap.ticker.add(this._call);
    };
    this.onHide = () => {
      gsap.ticker.remove(this._call);
    };
  }

  setUpAnimation() {
    if (isMobile) return;

    this.items = [...GetBy.class('__folder', this.item)];

    const n = this.items.length;
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      gsap.set(item, {
        y: `${(n - i) * 100}%`
      });
    }
  }

  loop() {
    if (isMobile) return;

    const p = Math.max(Maths.map(-1 * this.progressInside, 1.25, 0, 1, 0), 0);
    const n = this.items.length;
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      gsap.set(item, {
        y: `${p * (n - i) * 100}%`
      });
    }
  }
}

Scroll._registerClass('footer', ScrollItem__Footer);